const defaultState={
    data:null
}
const DashboardDataReducer =async (state=defaultState,action)=>{

    switch(action.type){
        case "DASHBOARDDATA": 
            return {...state,data:action.payload.data}
        case "FAIL":
            return {...state,data:null}
        default:
            return state;
    }

}
export default DashboardDataReducer;